// $(".gallery-slide").owlCarousel({
//   loop: true,
//   margin: 10,
//   nav: true,
//   dots: false,
//   margin: 10,
//   autoplay: false,
//   autoWidth: true,
//   center: true,
//   items: 5,
//   navText: [
//     '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>',
//     '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',
//   ],
//   responsive: {
//     0: {
//       items: 1,
//       margin: 0,
//     },
//     600: {
//       items: 1,
//     },
//     1000: {
//       items: 5,
//     },
//   },
// });

$(".gallery-slide").slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 2000,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  centerMode: true,
  variableWidth: true,
  prevArrow: '<div class="slick-prev"></div>',
  nextArrow: '<div class="slick-next"></div>',
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
});

document.addEventListener("DOMContentLoaded", function () {
  const contactForm = document.getElementById("ContactForm");

  if (contactForm) {
    contactForm.addEventListener("submit", function (event) {
      const subscribeCheckbox = document.getElementById("subscribeNewsletter");

      if (subscribeCheckbox && subscribeCheckbox.checked) {
        event.preventDefault(); // Prevent form from submitting immediately

        const formData = new FormData(contactForm);

        // Add the user to the subscriber list
        fetch("/path-to-your-subscriber-endpoint", {
          method: "POST",
          body: JSON.stringify({
            email: formData.get("contact[email]"), // Adjust this to the correct field name
            subscribe: true,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            // Handle the response from the server
            console.log("Subscription successful", data);

            // Now submit the contact form
            contactForm.submit();
          })
          .catch((error) => {
            console.error("Error adding subscriber:", error);
            // Optionally show an error message to the user
          });
      }
    });
  }
});
